import httpClient from './http-client';

/** Scopes the authorization server knows; mirrors the API catalog. */
export type OAuthConsentScope =
  | 'profile:read'
  | 'case_request:read'
  | 'case_request:write'
  | 'case_news:write'
  | 'artifact:write'
  | 'claim:write'
  | 'company:read'
  | 'users:read';

/** What the consent screen shows: who asks, for what, and as whom. */
export interface IOAuthAuthorizationRequest {
  client: { name: string };
  scopes: OAuthConsentScope[];
  account: {
    email: string;
    firstName: string;
    lastName: string;
    company: { id: number; name: string };
  };
  expiresAt: string;
}

export type OAuthConsentDecision = 'approve' | 'deny';

/** Consent screen calls of the OAuth authorization server (session cookie). */
export class OAuthConsentService {
  static async retrieveAuthorizationRequest(
    requestId: string
  ): Promise<IOAuthAuthorizationRequest> {
    const response = await httpClient.get(
      `/v1/oauth/authorize/${encodeURIComponent(requestId)}`
    );

    return response.data;
  }

  static async decideAuthorizationRequest(
    requestId: string,
    decision: OAuthConsentDecision
  ): Promise<{ redirectTo: string }> {
    const response = await httpClient.post(
      `/v1/oauth/authorize/${encodeURIComponent(requestId)}/decision`,
      { decision }
    );

    return response.data;
  }
}
